import { render, staticRenderFns } from "./_FarmQueue.vue?vue&type=template&id=f2af1b3a&"
import script from "./_FarmQueue.vue?vue&type=script&lang=js&"
export * from "./_FarmQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports